<template>
	<NavBar class="shrink-0"/>
	<router-view class="grow-1 overflow-y-scroll" />
	<NavBarMobile class="md:hidden" />
</template>

<script setup>
import NavBar from "@/components/NavBar.vue"
import NavBarMobile from "@/components/NavBarMobile.vue";
import { onMounted } from "vue";
import { StationsData } from "./state/StationsData";
import { User } from "./state/User";

// Set favicon based on device theme
function setFavicon() {
	const favicon = document.querySelector('link[rel="icon"]')
	favicon.href = (window.matchMedia('(prefers-color-scheme: dark)').matches)
		? '/logo-white.svg'
		: '/logo-black.svg'
}

onMounted(() => {
	// Setup station data auto update
	if (StationsData.autoUpdate == false) StationsData.setupAutoUpdating()

	// Login user
	if (User.fetchProfile()) console.log("User login")

	// Set favicon
	setFavicon()
	window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', setFavicon)
})
</script>

<style>

</style>
